// File: /src/components/GenReceipt.js

import { jsPDF } from 'jspdf';
import { toast } from 'react-toastify';
import apiClient from '../services/apiClient';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const generateReceiptPdf = async (
	invoices,
	selectedInvoices,
	clients = [],
	projects = []
) => {
	const selectedReceipts = invoices.filter((invoice) =>
		selectedInvoices.includes(invoice.id)
	);

	if (selectedReceipts.length === 0) {
		toast.error('Nenhuma fatura selecionada para emissão.');
		return;
	}

	try {
		const response = await apiClient.get(
			API_ENDPOINTS.USERS_ME
		);
		const user = response.data;

		selectedReceipts.forEach((invoice) => {
			// Buscando o projeto e o cliente usando conversão flexível e considerando ambos os nomes
			const project =
				projects.find((p) => p.id === invoice.projectId) || {};
			const client =
				clients.find(
					(c) => c.id === (project.clientId || project.client_id)
				) || {};

			const clientName = client.name || 'Cliente não encontrado';
			const clientCpfCnpj = client.cpf_cnpj || 'N/A';
			const clientEmail = client.email || 'N/A';
			const projectName = project.name || 'Projeto não encontrado';

			const doc = new jsPDF();

			// Título do recibo
			doc.setFontSize(18);
			doc.text('Recibo de Pagamento', 105, 20, { align: 'center' });

			doc.setFontSize(14);
			doc.text(user.name, 105, 30, { align: 'center' });

			if (user.cpf_cnpj) {
				const cpfCnpjClean = user.cpf_cnpj.replace(/\D/g, '');
				let label = 'CPF/CNPJ';
				if (cpfCnpjClean.length === 11) {
					label = 'CPF';
				} else if (cpfCnpjClean.length === 14) {
					label = 'CNPJ';
				}
				doc.setFontSize(12);
				doc.text(`${label}: ${user.cpf_cnpj}`, 105, 38, {
					align: 'center',
				});
			}

			if (user.email) {
				doc.setFontSize(12);
				doc.text(`E-mail: ${user.email}`, 105, 46, { align: 'center' });
			}

			// Linha separadora
			doc.setLineWidth(0.5);
			doc.line(20, 50, 190, 50);

			// Informações do Cliente
			doc.setFontSize(12);
			doc.text('Dados do Cliente:', 20, 60);
			doc.text(`Nome: ${clientName}`, 20, 70);
			doc.text(`CPF/CNPJ: ${clientCpfCnpj}`, 20, 80);
			doc.text(`E-mail: ${clientEmail}`, 20, 90);

			// Informações do Projeto
			doc.text('Projeto Prestado:', 20, 105);
			doc.text(`Projeto: ${projectName}`, 20, 115);
			doc.text(`Descrição: ${invoice.description}`, 20, 125);

			// Informações da Fatura
			doc.text('Detalhes da Fatura:', 20, 140);
			doc.text(
				`Valor: R$ ${Number(invoice.value).toLocaleString('pt-BR', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				})}`,
				20,
				150
			);
			doc.text(
				`Data de Vencimento: ${new Date(
					invoice.due_date
				).toLocaleDateString('pt-BR')}`,
				20,
				160
			);

			// Linha separadora
			doc.line(20, 180, 190, 180);

			// Rodapé
			doc.setFontSize(10);
			doc.text(
				'Este recibo é válido como comprovante de pagamento.',
				105,
				205,
				{ align: 'center' }
			);

			// Salvar PDF
			doc.save(`recibo_fatura_${invoice.id}.pdf`);
		});

		toast.success('Recibos gerados com sucesso!');
	} catch (error) {
		console.error('❌ Erro ao obter informações do usuário:', error);
		toast.error('Erro ao obter informações do usuário.');
	}
};
